export default class SearchTabs {
    constructor() {
        this.tabs = [...document.querySelectorAll(".tabs__label")];
        this.tabsContent = [...document.querySelectorAll(".tabs__content")];

        if (this.tabs.length) {
            this.events();
        }
    }

    events() {
        this.displayKeywords();
    }

    displayKeywords() {
        this.tabs.forEach((tab) =>
            tab.addEventListener("click", (e) => {
                [].forEach.call(this.tabsContent, function (div) {
                    div.style.display = "none";
                });

                document.querySelector(
                    '[data-category="' + e.target.dataset.cat + '"]'
                ).style.display = "flex";
            })
        );
    }
}
